const COUNTRIES_WITHOUT_CITY_NAME_IN_HEADING = ["US", "GB", "AU", "CA", "IE"];
const getRegionHeading = (regionObject: any, withoutMarkup: boolean, lang = "") => {
  let regionHeading = "Student Housing";
  if (regionObject && regionObject.name) {
    let regionName = "";
    if (regionName.length === 0 && regionObject.meta && regionObject.meta.region_name) {
      regionName = regionObject.meta.region_name;
    }
    if (lang === "zh") {
      regionName = regionObject.name || regionName;
    }

    if (regionName.length === 0) {
      const regionNames = [];
      regionNames.push(regionObject.name);
      const countryShortName = regionObject?.location?.country?.short_name;
      const shouldHideCity = COUNTRIES_WITHOUT_CITY_NAME_IN_HEADING.includes(countryShortName);
      if (
        regionObject.region_type === "establishment" &&
        regionObject.parent_name &&
        !shouldHideCity
      ) {
        regionNames.push(regionObject.parent_name);
      }
      regionName = regionNames.join(", ");
    }
    if (regionName.length > 0) {
      if (
        regionObject.meta &&
        regionObject.meta.heading &&
        regionObject.meta.heading.includes("region_name")
      ) {
        regionHeading = `<b>${
          lang === "zh" ? regionName : regionObject.meta.region_name || regionName
        }</b>`;
      } else {
        regionHeading = regionName;
      }
      if (withoutMarkup) {
        regionHeading = regionHeading.replace(/<\/?b>/gim, "");
      } // Replaces all <b></b> tags
    }
  }
  return regionHeading;
};

const headingNameToken = (regionObject: any, lang = "") => {
  if (lang === "zh") {
    return regionObject?.name || regionObject?.meta?.region_name || "";
  }
  return regionObject?.meta?.region_name || regionObject?.name || "";
};

export const getSearchPageHeadingName = (
  regionObject: any,
  { isWhitelabel = false, lang = "" }: { isWhitelabel?: boolean; lang?: string } = {},
) => {
  const currentHeading = getRegionHeading(regionObject, true, lang);
  if (isWhitelabel || regionObject?.region_type !== "establishment") {
    return currentHeading;
  }
  const abbreviation =
    typeof regionObject?.abbreviation === "string" ? regionObject.abbreviation.trim() : "";
  if (!abbreviation) {
    return currentHeading;
  }
  const token = headingNameToken(regionObject, lang);
  if (token && currentHeading.startsWith(token)) {
    return `${abbreviation}${currentHeading.slice(token.length)}`;
  }
  return currentHeading;
};

export default getRegionHeading;
